<template>
  <div>
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </div>
</template>

<script setup lang="ts">
import { useHeadConfigComposable } from '~/modules/head/composables/useHeadConfigComposable'
useHeadConfigComposable()
</script>
